import { useQueryInterop } from '@confluence/apollo-relay-interop';
import { expValEquals } from '@confluence/feature-experiments';

import {
	default as IsMarkdownModeQuery,
	type IsMarkdownModeQuery$data,
	type IsMarkdownModeQuery$variables,
} from './__generated__/IsMarkdownModeQuery.graphql.ts';
import { getIsMarkdownModeFromData } from './getIsMarkdownModeFromData.ts';

// `fetchPolicy: 'cache-only'` is intentional: the field is already populated
// in the cache by `ContentHeaderUnifiedQuery` (executed by `ContentHeader`,
// `ByLine`, `ContentTitle`, and the SSR preloader on every route that renders
// the unified page header). The selection here resolves against the same
// normalised cache entry, so no network request is fired.
export const useIsMarkdownMode = (contentId: string): boolean => {
	const { data } = useQueryInterop<IsMarkdownModeQuery$data, IsMarkdownModeQuery$variables>(
		IsMarkdownModeQuery,
		{
			variables: {
				contentId,
				isMarkdownModeEnabled: expValEquals('cc-markdown-mode', 'isEnabled', true),
			},
			fetchPolicy: 'cache-only',
			skip: !contentId || !expValEquals('cc-markdown-mode', 'isEnabled', true),
		},
	);

	return getIsMarkdownModeFromData(data);
};
